<template>
    <el-dialog
        title="付款确认"
        :visible.sync="payablePaymentDialog"
        width="800px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="false"
        custom-class="custom-form-dialog custom-payable-dialog"
    >
        <div class="page_little_title">基本信息</div>
        <el-form
            ref="paymentInfoForm"
            :rules="paymentInfoFormRules"
            :model="paymentInfoForm"
            label-position="top"
            v-loading="formLoading"
        >
            <div v-if="type === 'payment'">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="应付未付金额" prop="unpaid_amount">
                            <el-input
                                disabled
                                placeholder="系统自动带出"
                                v-model="payableDetails.basic_info.unpaid_amount"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="支付方式" prop="payment_method">
                            <el-select placeholder="请选择支付方式" v-model="paymentInfoForm.payment_method">
                                <el-option
                                    :label="item.name"
                                    :value="item.value"
                                    v-for="item in payTypeList"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="付款金额" prop="payment_amount">
                            <el-input
                                @blur="handlePayAmountBlur(paymentInfoForm, payableDetails.basic_info.unpaid_amount)"
                                placeholder="请输入付款金额"
                                v-model="paymentInfoForm.payment_amount"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="付款时间" prop="payment_time">
                            <el-date-picker
                                format="yyyy-MM-dd HH:mm:ss"
                                placeholder="请选择付款时间"
                                type="datetime"
                                v-model="paymentInfoForm.payment_time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-row :gutter="24" v-if="type === 'batch_payment'">
                <el-col :span="12">
                    <el-form-item label="支付方式" prop="payment_method">
                        <el-select placeholder="请选择支付方式" v-model="paymentInfoForm.payment_method">
                            <el-option :label="item.name" :value="item.value" v-for="item in payTypeList"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="付款时间" prop="payment_time">
                        <el-date-picker
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择付款时间"
                            type="datetime"
                            v-model="paymentInfoForm.payment_time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <div v-if="type === 'batch_payment'">
                <div class="page_little_title">支付信息</div>
                <el-table :data="payableBatchPayInfo" size="small" border class="custom_table">
                    <el-table-column label="应付编号" min-width="158" prop="payable_no" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            <el-link
                                :underline="false"
                                @click="handleClickPayableDetail(row)"
                                type="primary"
                                v-text="row.payable_no"
                            >
                            </el-link>
                        </template>
                    </el-table-column>
                    <template v-if="payable_type == 'purchase'">
                        <el-table-column
                            prop="supplier_name"
                            label="供应商名称"
                            min-width="150"
                            show-overflow-tooltip
                            key="1"
                        >
                            <template slot-scope="{ row }">
                                <span>{{ row.detail && row.detail.supplier_name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购编号" min-width="160" show-overflow-tooltip key="2">
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickRelateId(row.relate_id)"
                                    type="primary"
                                    v-text="row.detail && row.detail.purchase_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else-if="payable_type == 'order_return'">
                        <el-table-column label="客户公司" min-width="150" show-overflow-tooltip key="3">
                            <template slot-scope="{ row }">
                                <span>{{
                                    row.detail && row.detail.customer_info && row.detail.customer_info.name
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单编号" min-width="140" show-overflow-tooltip key="4">
                            <template slot-scope="{ row }">
                                <el-link
                                    :underline="false"
                                    @click="handleClickOrderDetail(row.relate_id, row.detail && row.detail.order_no)"
                                    type="primary"
                                    v-text="row.detail && row.detail.order_no"
                                >
                                </el-link>
                            </template>
                        </el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="payee_name" label="收款方" min-width="150" show-overflow-tooltip key="5">
                            <template slot-scope="{ row }">
                                <span>{{ row.detail && row.detail.payee_name }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <el-table-column label="审批编号" min-width="100">
                        <template slot-scope="{ row }">
                            <el-link
                                :underline="false"
                                @click="handleClickApprovalDetail(row.approval_id)"
                                type="primary"
                                v-text="row.approval_id"
                                v-if="row.approval_id"
                            >
                            </el-link>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" label="申请人" prop="user_name" min-width="130">
                        <template #default="{ row }">
                            <PersonnelCard :userId="row.uid_info.id" v-if="row.uid_info && row.uid_info.id">
                                <template slot="container">
                                    <div class="user-avatar-btn">
                                        <img :src="row.uid_info.avatar ? row.uid_info.avatar : defaultImg" alt="" />
                                        <span>{{ row.uid_info.name }}</span>
                                    </div>
                                </template>
                            </PersonnelCard>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="right"
                        label="应付金额"
                        prop="payable_amount"
                        min-width="116"
                    ></el-table-column>
                    <el-table-column
                        align="right"
                        label="未付金额"
                        prop="unpaid_amount"
                        min-width="116"
                    ></el-table-column>
                    <el-table-column align="right" label="支付金额" prop="payment_amount" min-width="126">
                        <template slot-scope="{ row }">
                            <el-input
                                @blur="handlePayAmountBlur(row, row.unpaid_amount)"
                                class="pay_amount_input"
                                size="small"
                                v-model="row.payment_amount"
                                placeholder="请输入支付金额"
                            >
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" fixed="right" label="操作" width="62">
                        <template slot-scope="{ row }">
                            <i class="iconfont icon-shanchu1 cursor" @click="handleClickBatchDelete(row)"></i>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="total_payment mb_24">
                    <span
                        >应付总金额：{{
                            payableBatchPayInfo
                                .reduce((total, item) => total + Number(item.payable_amount), 0)
                                .toFixed(2)
                        }}</span
                    >
                    <span
                        >未付总金额：{{
                            payableBatchPayInfo
                                .reduce((total, item) => total + Number(item.unpaid_amount), 0)
                                .toFixed(2)
                        }}</span
                    >
                    <span
                        >支付总金额：{{
                            payableBatchPayInfo
                                .reduce((total, item) => total + Number(item.payment_amount), 0)
                                .toFixed(2)
                        }}</span
                    >
                </div>
            </div>
            <el-row>
                <el-col :span="18">
                    <el-form-item label="备注" prop="remarks">
                        <el-input
                            :rows="4"
                            maxlength="200"
                            placeholder="请输入备注信息"
                            type="textarea"
                            v-model="paymentInfoForm.remarks"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="支付凭证" prop="voucher">
                <ul class="voucher_list">
                    <li :key="index" class="voucher_item" v-for="(item, index) in paymentInfoForm.voucher">
                        <el-image :preview-src-list="paymentInfoForm.voucher" :src="item" alt=""> </el-image>
                        <i @click="paymentInfoForm.voucher.splice(index, 1)" class="iconfont icon-jianqu"></i>
                    </li>
                    <li @click="handleClickUploadFile" class="upload_img_wrap">
                        <i class="el-icon-plus"></i>
                    </li>
                </ul>
                <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
            </el-form-item>
            <!-- 部分支付或全部支付后 -->
            <div v-if="payableDetails.payment_records && payableDetails.payment_records.length > 0">
                <div class="page_little_title">支付记录</div>
                <el-table :data="payableDetails.payment_records" size="small" class="custom_table" border>
                    <el-table-column label="付款时间" min-width="150" prop="payment_time"></el-table-column>
                    <el-table-column align="left" label="支付方式" min-width="100" prop="payment_method">
                        <template slot-scope="{ row }">
                            <span>{{ payTypeList.find((item) => item.value == row.payment_method)?.name || "" }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="right"
                        label="支付金额"
                        min-width="140"
                        prop="payment_amount"
                    ></el-table-column>
                    <el-table-column align="left" label="备注" min-width="150" prop="remarks"></el-table-column>
                    <el-table-column align="left" label="支付凭证" width="130" prop="voucher">
                        <template slot-scope="{ row }">
                            <div
                                style="display: flex; align-items: center; justify-content: left"
                                class="table_img_wrap"
                            >
                                <el-image
                                    :preview-src-list="row.voucher"
                                    :src="row.voucher[0]"
                                    title="支付凭证"
                                    alt=""
                                    style="max-width: 32px; max-height: 32px"
                                    v-if="row.voucher && row.voucher.length > 0"
                                >
                                </el-image>
                                <el-popover
                                    placement="bottom-start"
                                    title=""
                                    width="248"
                                    trigger="click"
                                    content=""
                                    popper-class="table_img_popover"
                                >
                                    <ul class="voucher_list">
                                        <li :key="index" class="voucher_item" v-for="(item, index) in row.voucher">
                                            <el-image
                                                :preview-src-list="row.voucher"
                                                :src="item"
                                                alt=""
                                                style="max-width: 32px; max-height: 32px"
                                            ></el-image>
                                        </li>
                                    </ul>
                                    <div
                                        slot="reference"
                                        class="table_img_mark"
                                        v-if="row.voucher && row.voucher.length > 1"
                                    >
                                        <span>{{ row.voucher.length }}</span>
                                    </div>
                                </el-popover>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <p
                    class="total_payment mb_24"
                    v-html="
                        '支付总金额：' +
                        payableDetails.payment_records.reduce((total, item) => total + Number(item.payment_amount), 0)
                    "
                ></p>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">提交</el-button>
        </span>
        <PurchaseDetail
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            v-if="purchaseDetailVisible"
            :purchaseId="purchaseId"
        />
    </el-dialog>
</template>
<script>
import { PayableDetail, PayableInfoByNos, PayablePaymentAdd, PayableBatchPayment } from "@/api";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PurchaseDetail from "../../../Purchase/component/purchase_detail.vue";
import { uploadImg } from "@/utils/uploadOss";
import { formatDate } from "@/utils";
export default {
    name: "PayablePayment",
    props: {
        payablePaymentDialog: {
            type: Boolean,
            default: false,
        },
        payable_no: "", // 应付编号
        type: {
            type: String,
            default: "",
        }, // payment:单个付款，batch_payment：批量付款
        payable_type: {
            type: String,
            default: "",
        }, // 采购=purcahse，订单：order_return, 否则就是自定义控件的
    },
    components: { PersonnelCard, PurchaseDetail },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            formLoading: true,
            payableDetails: {
                basic_info: {}, // 基础信息
                cancel_info: {},
                payee_info: {}, //收款方信息
                payment_records: [], //付款记录
            },
            paymentInfoForm: {
                payment_method: 1,
                payment_amount: "",
                payment_time: formatDate(new Date(), "date-second-time"),
                remarks: "",
                voucher: [],
                paylog_bill: [],
            },
            paymentInfoFormRules: {
                payment_amount: [
                    {
                        required: true,
                        trigger: "blur",
                        validator: (rule, value, callback) => {
                            if (!value) callback(new Error("请输入付款金额"));
                            if (Number(value) > Number(this.payableDetails.basic_info.unpaid_amount))
                                return callback(new Error("付款金额不能大于未付总金额"));
                            callback();
                        },
                    },
                ],
                payment_time: [{ required: true, message: "请选择付款时间", trigger: "change" }],
            },
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            btnDisabled: false,
            payableBatchPayInfo: [], // 批量支付信息

            // 采购详情
            purchaseDetailVisible: false,
            purchaseId: "",

            // 应付详情
            payableDetailsDialogVisible: false,
            payment_payable_no: "",
        };
    },
    created() {
        if (this.payable_no) {
            if (this.type === "payment") {
                // 单个
                this.getPayableDetail();
            } else {
                // 批量
                this.getPayableBatchPayInfo();
            }
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:payablePaymentDialog", false);
        },
        // 应付详情
        getPayableDetail() {
            this.formLoading = true;
            PayableDetail({ payable_no: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.payableDetails = data;
                    if (this.payableDetails.basic_info) {
                        this.paymentInfoForm.payment_amount = this.payableDetails.basic_info.unpaid_amount;
                    }
                }
                this.formLoading = false;
            });
        },
        // 获取批量详情数据
        getPayableBatchPayInfo() {
            this.formLoading = true;
            PayableInfoByNos({ payable_nos: this.payable_no }).then((res) => {
                if (res.code === 200) {
                    res.data.forEach((item) => {
                        item.payment_amount = item.unpaid_amount;
                    });
                    this.payableBatchPayInfo = res.data || [];
                }
                this.formLoading = false;
            });
        },
        //格式化输入的支付金额
        handlePayAmountBlur(formData, unpaid_amount) {
            formData["payment_amount"] = formData["payment_amount"].replace(/[^\d\.]/g, "");
            if (Number(formData["payment_amount"]) > Number(unpaid_amount)) {
                formData["payment_amount"] = unpaid_amount;
            }
            if (formData["payment_amount"]) {
                let amount = Math.abs(parseFloat(formData["payment_amount"]));
                const some = unpaid_amount.toString().split(".")[1].length;
                const parts = amount.toFixed(some).split(".");
                const integerPart = parts[0];
                const decimalPart = some > 0 ? (parts[1] ? parts[1] : "0".repeat(some)) : "";
                // 拼接成完整的金额格式
                formData["payment_amount"] = some > 0 ? `${integerPart}.${decimalPart}` : integerPart;
            }
        },
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024))
                    return that.$message.error("图片大小不允许超过5m");
                // if (that.paymentInfoForm.voucher.length + files.length > 5)
                //     return that.$message.error("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.paymentInfoForm.voucher.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 批量支付的时候删除某个
        handleClickBatchDelete(row) {
            const index = this.payableBatchPayInfo.findIndex((item) => item.payable_no === row.payable_no);
            this.payableBatchPayInfo.splice(index, 1);
        },
        // 应付详情
        handleClickPayableDetail(row) {
            this.$emit("handleAgainLookPayableDetail", row);
        },
        handelDetailPayment() {},
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.purchaseId = purchaseId;
            this.purchaseDetailVisible = true;
        },
        // 审批详情
        handleClickApprovalDetail(approval_id) {
            this.$showApprovalDetail({
                approval_id,
            }).then((res) => {});
        },
        // 查看订单详情
        handleClickOrderDetail(order_id, order_no) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_id,
                    name: order_no,
                },
            });
        },
        handleDialogConfirm() {
            this.$refs.paymentInfoForm.validate((valid) => {
                if (valid) {
                    let params = {
                        payment_method: this.paymentInfoForm.payment_method,
                        payment_time: this.paymentInfoForm.payment_time,
                        remarks: this.paymentInfoForm.remarks,
                        voucher: this.paymentInfoForm.voucher,
                    };
                    if (this.type === "payment") {
                        // 单个付款
                        this.btnDisabled = true;
                        this.formLoading = true;
                        params.payable_no = this.payable_no;
                        params.payment_amount = this.paymentInfoForm.payment_amount;
                        PayablePaymentAdd(params)
                            .then((res) => {
                                if (res.code === 200) {
                                    this.btnDisabled = false;
                                    this.formLoading = false;
                                    this.$message({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$emit("paymentSuccess");
                                            this.handleDialogClose();
                                        },
                                    });
                                } else {
                                    this.btnDisabled = false;
                                    this.formLoading = false;
                                    this.$message.error(res.message);
                                }
                            })
                            .catch(() => {
                                this.btnDisabled = false;
                                this.formLoading = false;
                            });
                    } else {
                        // 批量付款
                        const isValid = this.payableBatchPayInfo.every((item) => item.payment_amount);
                        if (!isValid) return this.$message.error("请输入支付金额");
                        const isNotAmount = this.payableBatchPayInfo.some(item=> item.payment_amount == 0);
                        if(isNotAmount) return this.$message.error("支付金额不允许小于等于0")
                        this.btnDisabled = true;
                        this.formLoading = true;
                        let payables = this.payableBatchPayInfo.map((item) => {
                            return {
                                payable_no: item.payable_no,
                                payment_amount: item.payment_amount,
                            };
                        });
                        params.payables = payables;
                        PayableBatchPayment(params)
                            .then((res) => {
                                if (res.code === 200) {
                                    this.btnDisabled = false;
                                    this.formLoading = false;
                                    this.$message({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.$emit("paymentSuccess");
                                            this.handleDialogClose();
                                        },
                                    });
                                } else {
                                    this.btnDisabled = false;
                                    this.formLoading = false;
                                    this.$message.error(res.message);
                                }
                            })
                            .catch(() => {
                                this.btnDisabled = false;
                                this.formLoading = false;
                            });
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss">
.mb_24 {
    margin-bottom: 24px;
}
.custom-payable-dialog {
    .el-dialog__body {
        max-height: 660px;
        overflow-y: auto;
    }
    .page_little_title {
        line-height: 22px;
        color: #333333;
        font-weight: 700;
        padding-left: 8px;
        position: relative;
        margin-bottom: 16px;

        &::before {
            width: 3px;
            height: 22px;
            border-radius: 2px;
            background: #409eff;
            content: "";
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .voucher_list {
        display: flex;
        gap: 8px;

        .upload_img_wrap {
            width: 48px;
            height: 48px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-icon-plus {
                color: #666666;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .voucher_item {
            width: 48px;
            height: 48px;
            border: 1px dashed #d9d9d9;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 48px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }

            .icon-jianqu {
                position: absolute;
                right: -8px;
                top: -8px;
                cursor: pointer;
                font-size: 16px;
                color: rgba(255, 77, 79, 1);
                line-height: 16px;
            }
        }
    }
    .total_payment {
        width: 100%;
        padding: 8px 12px;
        border-radius: 6px 6px, 0px, 0px;
        background: rgba(237, 240, 244, 1);
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-right: 24px;
        }
    }
    .el-form {
        .el-row {
            .el-link--primary {
                display: block;
            }
        }
    }
}
.table_img_popover {
    padding: 8px;
    .voucher_list {
        display: flex;
        gap: 8px;
        .voucher_item {
            width: 32px;
            height: 32px;
            cursor: pointer;
            position: relative;
            text-align: center;
            line-height: 32px;
            border-radius: 4px;

            .el-image {
                max-width: 100%;
                max-height: 100%;
            }

            img {
                max-width: 100%;
                max-height: 100%;
                object-fit: cover;
            }
        }
    }
}
.table_img_wrap {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    .table_img_mark {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 32px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.6);
        cursor: pointer;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(255, 255, 255, 1);
        }
    }
}
.el-table {
    .pay_amount_input {
        .el-input__inner {
            padding: 0;
            border: 0;
            background: transparent;
            text-align: right;
        }
    }
}
</style>
